import React from 'react';

export default () => (
    <svg
        width="111"
        height="115"
        viewBox="0 0 111 115"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <rect id="path-1" y="16" width="75" height="99" />
            <mask id="mask-2" x="0" y="0" width="75" height="99" fill="#fff">
                <use xlinkHref="#path-1" />
            </mask>
            <filter
                x="-11.7%"
                y="-8.3%"
                width="126.7%"
                height="126.7%"
                filterUnits="objectBoundingBox"
                id="filter-3"
            >
                <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                    stdDeviation="1"
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                />
                <feColorMatrix
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>
        <g id="Page-1" fill="none" fillRule="evenodd">
            <g id="Group">
                <use
                    id="Rectangle"
                    stroke="#E7E7E7"
                    mask="url(#mask-2)"
                    strokeWidth="4"
                    strokeDasharray="4,4,4"
                    xlinkHref="#path-1"
                />
                <g id="Pic" transform="translate(17)">
                    <rect id="Rectangle-Copy" fill="#ECEEEF" width="75" height="99" />
                    <circle id="Oval" fill="#CCD2D9" cx="22.5" cy="37.5" r="11.5" />
                    <rect id="Rectangle-2" fill="#FFF" x="23" y="39" width="27" height="27" />
                    <polygon id="Triangle" fill="#CCD2D9" points="56 47 66 67 46 67" />
                </g>
                <g id="Cursor---Closed-hand" transform="translate(70 71)">
                    <polygon id="Mask" points="0 0 47 0 47 47 0 47" />
                    <g
                        id="Shape"
                        filter="url(#filter-3)"
                        transform="translate(8 8)"
                        stroke="#AAB4C1"
                        strokeWidth="0.75"
                        strokeLinecap="round"
                    >
                        <path
                            d="M8.48489375,16.0392063 C8.29501875,15.3126438 8.10514375,14.3981438 7.69826875,13.0322063 C7.37470625,11.9530188 7.03564375,11.3678938 6.78764375,10.6432688 C6.48733125,9.76170625 6.20058125,9.24633125 5.82664375,8.35508125 C5.55733125,7.71764375 5.12139375,6.32458125 4.94120625,5.56508125 C4.71064375,4.57889375 5.00514375,3.77483125 5.41395625,3.22845625 C5.90414375,2.57164375 7.27783125,2.27908125 8.04314375,2.54839375 C8.76195625,2.80026875 9.48464375,3.54039375 9.81789375,4.07514375 C10.3758937,4.96639375 10.5095812,5.29964375 11.2070812,7.06276875 C11.9685187,8.98476875 12.2998312,10.7788938 12.3908937,11.3853313 L12.5555812,12.2610813 C12.5536437,12.1835813 12.4722687,10.0872063 12.4703312,10.0097063 C12.4025187,8.01601875 12.3540812,6.47764375 12.3967062,4.31539375 C12.4005812,4.07126875 12.5207062,3.17808125 12.5594562,2.93008125 C12.7105812,1.96133125 13.1503937,1.38008125 13.8633937,1.03326875 C14.6616437,0.64383125 15.6575187,0.61670625 16.5778312,1.00033125 C17.3973937,1.33551875 17.7907062,2.06595625 17.9088937,2.98045625 C17.9360187,3.19164375 18.0910187,4.89276875 18.0890812,5.12526875 C18.0638937,7.11120625 18.1007062,8.30470625 18.1181437,9.33739375 C18.1258937,9.78495625 18.1239562,12.4858313 18.1510812,12.1835813 C18.2692687,10.9125813 18.3332062,6.00489375 18.8175812,4.54595625 C19.0965812,3.70701875 19.6022687,3.10058125 20.3559562,2.74601875 C21.1910187,2.35270625 22.5123937,2.61039375 23.0762062,3.21683125 C23.6283937,3.80776875 23.9403312,4.55758125 24.0100812,5.45076875 C24.0720812,6.23545625 23.9732687,7.18870625 23.9713312,7.86295625 C23.9713312,9.54276875 23.9306437,10.4282063 23.8996437,11.9723938 C23.8977062,12.0460188 23.8705812,12.5497688 23.9442062,12.3250188 C24.1263312,11.7825188 24.3084562,11.2748938 24.4595812,10.8815813 C24.5545187,10.6393938 24.9265187,9.69195625 25.1551437,9.21726875 C25.3760187,8.76389375 25.5639562,8.50233125 25.9592062,7.88426875 C26.3467062,7.27783125 26.7632687,7.01626875 27.2534562,6.79733125 C28.2997062,6.34201875 29.4021437,7.01433125 29.7741437,7.94239375 C29.9407687,8.35895625 29.7915812,9.32383125 29.7198937,10.0833313 C29.6017062,11.3368938 29.2277687,12.6137063 29.0378937,13.2763313 C28.7898937,14.1423938 28.5070187,15.6691438 28.3791437,16.3782688 C28.2396437,17.1416438 27.9257687,19.0558938 27.6835812,19.9045188 C27.5169562,20.4877063 26.9647687,21.7993938 26.4203312,22.5860188 C26.4203312,22.5860188 24.3394562,25.0078938 24.1108312,26.0967688 C23.8841437,27.1875813 23.9597062,27.1953313 23.9151437,27.9664563 C23.8686437,28.7395188 24.1495812,29.7547688 24.1495812,29.7547688 C24.1495812,29.7547688 22.5957062,29.9562688 21.7587062,29.8206438 C21.0011437,29.7005188 20.0633937,28.1912063 19.8212062,27.7320188 C19.4879562,27.0965188 18.7768937,27.2185813 18.4998312,27.6874563 C18.0638937,28.4295188 17.1261437,29.7605813 16.4635187,29.8438938 C15.1692687,30.0066438 12.4838937,29.9020188 10.3817062,29.8826438 C10.3817062,29.8826438 10.7401437,27.9238313 9.94189375,27.2515188 C9.35095625,26.7477688 8.33376875,25.7325188 7.72539375,25.1977688 L6.11339375,23.4133313 C5.56314375,22.7158313 4.89470625,21.2956438 3.70508125,19.5673938 C3.03083125,18.5908938 1.71526875,17.4652063 1.21733125,16.5080813 C0.78526875,15.6846438 0.57601875,14.6597063 0.84920625,13.9408938 C1.28514375,12.7900188 2.15701875,12.2029563 3.48808125,12.3288938 C4.49364375,12.4257688 5.13108125,12.7280188 5.88670625,13.3693313 C6.32264375,13.7374563 6.99689375,14.4039563 7.33983125,14.8185813 C7.65564375,15.1963938 7.73314375,15.3533313 8.07026875,15.8047688 C8.51589375,16.3995813 8.65539375,16.6940813 8.48489375,16.0392063"
                            id="Stroke-1"
                            fill="#FFF"
                            strokeLinejoin="round"
                        />
                        <path d="M22.068125,24.0995938 L22.068125,17.3977813" id="Stroke-3" />
                        <path d="M18.1629,24.1222625 L18.1319,17.393325" id="Stroke-5" />
                        <path d="M14.2954562,17.45455 L14.3361437,24.092425" id="Stroke-7" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/EmptySet.js